/* eslint-disable */

function getCoverURL(book, callback) {
    book.coverUrl().then(function (blobUrl) {
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function () {
            var recoveredBlob = xhr.response;
            var reader = new FileReader();
            reader.onload = function () {
                callback && callback(reader.result);
            };
            reader.readAsDataURL(recoveredBlob);
        };
        xhr.open('GET', blobUrl);
        xhr.send();
    });
}

export {getCoverURL}
      /**
* 数字转成汉字
* @params num === 要转换的数字
* @return 汉字
* */
export function toChinesNum(num) {
 let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
 let unit = ['', '十', '百', '千', '万']
 num = parseInt(num)
 let getWan = (temp) => {
   let strArr = temp.toString().split('').reverse()
   let newNum = ''
   let newArr = []
   strArr.forEach((item, index) => {
     newArr.unshift(item === '0' ? changeNum[item] : changeNum[item] + unit[index])
   })
   let numArr = []
   newArr.forEach((m, n) => {
     if (m !== '零') numArr.push(n)
   })
   if (newArr.length > 1) {
     newArr.forEach((m, n) => {
       if (newArr[newArr.length - 1] === '零') {
         if (n <= numArr[numArr.length - 1]) {
           newNum += m
         }
       } else {
         newNum += m
       }
     })
   } else {
     newNum = newArr[0]
   }

   return newNum
 }
 let overWan = Math.floor(num / 10000)
 let noWan = num % 10000
 if (noWan.toString().length < 4) {
   noWan = '0' + noWan
 }
 return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
}